import React from "react";

function createMarkup(html) {
  return { __html: html };
}

export default ({
  name,
  label,
  reqd,
  value = "",
  options,
  update,
  error = false,
}) => {
  return (
    <div>
      <label className="control-label" htmlFor={name}>
        <span
          dangerouslySetInnerHTML={createMarkup(label)}
          style={{ color: error ? "#b94a48" : "inherit" }}
        />{" "}
        <span className="reqd">{reqd ? "*" : " "}</span>
      </label>
      <select
        className="form-control"
        placeholder=""
        autoComplete="off"
        onChange={(e) => update(name, e.target.value)}
        style={{ paddingLeft: "5px", borderColor: error ? "#b94a48" : "" }}
        defaultValue={value}
      >
        {options.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
  );
};
